import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global, BaoCao } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { LocalDataSource } from 'ng2-smart-table';
import { NumberViewComponent } from '../../../shared/components/public/numberview.component';
import { DateViewComponent } from '../../../shared/components/public/dateview.component';
import { FileRestrictions, SelectEvent, ClearEvent, RemoveEvent, FileInfo } from '@progress/kendo-angular-upload';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse, HttpEventType, HttpRequest } from '@angular/common/http';
import 'jquery'
import 'bootstrap'
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { Observable } from 'rxjs';
import { retry } from 'rxjs-compat/operator/retry';
import {
  Lists_loaikhoan, Lists_tieumuc, Lists_nguonkinhphi
  , Lists_danhmucdonvibanle, Ultil_donvi, Lists_danhmucthitruong, NghiepVus_quanlycapgiayphep
} from '../../../routes/menu'

const swal = require('sweetalert');


@Component({
    selector: 'app-tonghop-danhsachcapsogiayphepedit',
  templateUrl: './danhsachcapsogiayphepedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./danhsachcapsogiayphepedit.component.scss'],
    providers: [ListService, Repository]
})


export class danhsachcapsogiayphepeditComponent implements OnInit {

  inputdonvis: any;
  @ViewChild('modal', { static: false }) modal: ModalComponent;
  @ViewChild('dteChung', { static: false }) doituongchungedit: any;
  @Output() save: EventEmitter<any> = new EventEmitter();
  public loading = true;
  tong_tien: any;
  TatCa: boolean = false;
  public totalItems: number = 0;
  public currentPage: number = 1;
  public maxSize: number = 5;
  public TimKiem: string;
  public StartPage: number = 1;
  public EndPage: number = 20;
  public pageSize: number = 20;
  public pages: any;
  public totalPages: number;
  public TimKiems: any = {
    Don_Vi_Id: null
    , DonViId: null
    , DonVi2Id: null
    , Doanh_Nghiep_Id: null
    , UserName: null
    , Nam: null
    , NamSinh: null
    , TuNgay: null
    , DenNgay: null
    , Phan_He_Id: null
    , TimKiem: null
    , Loai: null
    , startPage: null
    , endPage: null
    , Ngay: null
    , NgayS: null
    , Ma: null
    , Ten: null
    , MoTa: null
    , GhiChu: null
    , SapXep: null
    , Modified: null
    , ModifiedS: null
    , ModifiedBy: null
    , DonViTinh: null
    , HangXe: null
    , ModelXe: null
    , GiaMua: null
    , MaKH: null
    , KhachHang: null
    , DienThoai: null
    , DiaChi: null
    , SoKhung: null
    , SoMay: null
    , KhoaHoc: null
    , TrangThaiS: null
    , SoGiayPhep: null
    , NgayCap: null
    , NgayHetHan: null
    , LoaiS: null
    , LoaiGiayPhep: null
    , DonVi: null


  };
  public ngaytimkiem: Date = null;
  TichTatCa() {
    this.datas.forEach((item: any) => {
      item.Tich = !this.TatCa;
    });
  }
  onKeydownEvent(event: KeyboardEvent): void {
    if (event.keyCode === 13) {
      this.search();
    }
  }
  pageChanged(event: any): void {
    // alert(event.page);
    //console.log('a');
    //console.log(event);
    this.currentPage = event.page;
    this.Loaddatas();
  }
  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }

    this.currentPage = page;
    this.Loaddatas();
  }
  public onBlur(): void {
    this.Loaddatas();
  }
  search() {
    this.currentPage = 1;
    this.pageSize = 20;
    this.Loaddatas();
  }
  search1() {
    this.Loaddatas();
  }



  doanhnghiepid: string = null;

  @ViewChild('modalimport', { static: false }) modalimport: ModalComponent;
  @ViewChild('dtimportexcel', { static: false }) importedit: any;





  public format: string = "dd/MM/yyyy";
  public enableMaskSupport: boolean = true;



  msg: string;




  indLoading: boolean = false;
  datas: any;
  modalTitle: string;
  modalBtnTitle: string;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  huongdan: string;

  idFocus: string = '00000000-0000-0000-0000-000000000000';
  nhomdoituongid: string = null;
  doituongid: any = null;
  donviid: any;
  currentUser: any;
  headerTitle: string = null;

  settings = {
    mode: 'external',
    selectMode: 'multi',
    pager: {
      display: true,
      perPage: 14
    },
    attr: {
      class: 'table table-striped table-bordered table-hover'
    },
    actions: {
      custom: [
        {
          name: 'edit',
          title: 'Sửa',
          class: 'mb-1 far fa-edit',
        },
        {
          name: 'delete',
          title: ' Xóa',
          class: 'mb-1 far fa-trash-alt',
        },

      ],
      columnTitle: 'Chức năng',
      add: false,
      edit: false,
      delete: false,
      width: '400px',
      position: 'right',
    },
    columns: {

      Ma: {
        name: 'Ma',
        title: 'Mã',
        width: '200px',
        type: 'custom',

      },
      Ten: {
        name: 'Ten',
        width: '400px',
        title: 'Tên',
        type: 'custom',

      }
      ,
      Cha: {
        name: 'Cha',
        title: 'Cấp trên',

      }
      ,
      Ghi_Chu: {
        name: 'Ghi_Chu',
        title: 'Ghi chú',

      }

      ,
      Modified: {
        name: 'Modified',
        title: 'Ngày sửa',
        width: '110px',
      }
      ,
      ModifiedBy: {
        name: 'ModifiedBy',
        title: 'Người sửa',

      }
    },
  };

  onCustom(event) {

    if (event.action == 'edit') {

      this.editdata(event.data.Id);
    }
    if (event.action == 'delete') {

      this.deletedata(event.data.Id);
    }

  }


  public length: number = 0;

  //-----------------cac hàm khởi tạo dữ liệu ban đầu
  constructor(private fb: FormBuilder, private _dataService: ListService, public repo: Repository) {



  }

  // @HostListener('document:keydown', ['$event'])
  public innerHeight: any
  mabaocao: string;
  noicapid: number;
  loadDataInit(id: string, pheid: string, mabaocao: string, capdonviid: number, donviid: number, noicapid: number) {
    this.mabaocao = mabaocao;
    this.ngaytimkiem = null;
    this.StartPage = 1;
    this.EndPage = 20;
    this.ngaytimkiem = null;
    this.innerHeight = window.innerHeight - 250;
    this.TimKiems.CapDonViId = capdonviid;
    this.TimKiems.DonViId = donviid;
    this.noicapid = noicapid;
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.donviid = donviid;
      this.TimKiems.DonViId = this.donviid;
      var giatri = this.currentUser.ds_quyen.filter(name => name.Id === NghiepVus_quanlycapgiayphep.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
        
      }
     
      
    }

   
    this.search();
        
    
  }

  
  Loaddatas(): void {
    this.loading = false;
    this.datas = [];
    this.StartPage = (this.currentPage - 1) * this.pageSize + 1;
    this.EndPage = this.currentPage * this.pageSize;
    this.totalItems = 0;
    this.TimKiems.UserName = this.currentUser.user_name;
    this.TimKiems.DonVi2Id = this.donviid;
    this.TimKiems.Don_Vi_Id = this.donviid;
    this.TimKiems.Phan_He_Id = NghiepVus_quanlycapgiayphep.id;
    //this.TimKiems.Ma_DV = this.currentUser.ma_dv;
    this.TimKiems.startPage = this.StartPage;
    this.TimKiems.endPage = this.EndPage;
    if (this.ngaytimkiem != null) {
      this.TimKiems.ModifiedS = this.ngaytimkiem.getFullYear() + '-' + (this.ngaytimkiem.getMonth() + 1) + '-' + this.ngaytimkiem.getDate();
    }
    else
      this.TimKiems.ModifiedS = null;


    let data = {
      Id: null,
      Type: null,
      Data: JSON.stringify(this.TimKiems)
    };
    $('#loading').show();
    this.repo.postRequest("api/giayphep/get_listviewpageds/", this.TimKiems)
      .subscribe(response => {
        $('#loading').hide();
        this.totalPages = 0;
        this.totalItems = 0;
        if (response.length > 0) {

          var item = response[0];
          this.totalItems = item["totalRows"];
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);

          let start, end;

          if (this.totalPages <= 5) {
            start = 1;
            end = this.totalPages;
          } else {
            if (this.currentPage <= 3) {
              start = 1;
              end = 5;
            } else if (this.currentPage + 1 >= this.totalPages) {
              start = this.totalPages - 4;
              end = this.totalPages;
            } else {
              start = this.currentPage - 2;
              end = this.currentPage + 2;
            }
          }

          let resultArray: Array<any> = [];
          for (var i = start; i <= end; i++) {
            resultArray.push({ Id: i, Ten: null });
          }
          this.pages = resultArray;
        }
        this.datas = response;

        (window as any).timer(3, 1000);

        //(window as any).timer(3, 1000);

      });



  }
  rowSelected: any = null;

  //------------------------------------
  selectedRows: any;
  onRowSelect(event) {
    this.selectedRows = event.selected;
  }
  adddata() {

    this.doituongid = null;
    this.modalTitle = "Thêm mới cấp giấy phép";
    this.modalBtnTitle = "Thêm";
    this.doituongchungedit.loadDataInit(NghiepVus_quanlycapgiayphep.id, null, this.donviid, this.noicapid, 1);
    this.modal.open();
    // this.modal.show();
  }
  //clonedata(row: any) {
  //  this.modalTitle = "Sao chép thông tin " + this.headerTitle;
  //  this.modalBtnTitle = "Cập nhật";
  //  this.doituongchungedit.loadDataInit(Lists_hedaotao.id, null, this.donviid, row);
  //  this.myModal.open();
  //  // this.modal.show();
  //}

  editdata(row: any) {
    console.log(row);
    this.doituongid = row.Id;
    this.modalTitle = "Cập nhập thông tin cấp giấy phép";
    this.modalBtnTitle = "Cập nhật";
    this.doituongchungedit.loadDataInit(NghiepVus_quanlycapgiayphep.id, row.Id, this.donviid, this.noicapid, 1);
    this.modal.open();
    // this.modal.show();
  }
  saveModal(id: any) {
    //console.log("saveModal tt");
    //console.log(id);
    if (id != null)
      this.Loaddatas();
    this.modal.dismiss();
    // this.modal.hide();
  }

  deletedata(id: string) {

    console.log(id);



    swal({
      title: 'Bạn muốn xóa bản ghi?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
          className: "bg-danger"
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-success",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {

          $('#loading').show();
          this.repo.postRequest('api/giayphep/delete/', { IdGuid: id, PhanHeId: NghiepVus_quanlycapgiayphep.id, UserName: this.currentUser.user_name }).subscribe(
            data => {
              $('#loading').hide();
              if (data == "OK") //Success
              {
                swal('Deleted!', 'Dữ liệu đã được xóa!.', 'success');

                this.Loaddatas();
              }
              else {
                // this.msg = data;
                swal('Cảnh báo!', data, 'warning');
              }


            },
            error => {
              this.msg = error;
            }
          );
        }
      });


  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngOnInit(): void {
    var crru = JSON.parse(localStorage.getItem('currentUser'));
    if (crru != null) {
      this.donviid = crru.id_don_vi;
      
    }
    this.LoadCategory();
  }

  LoadCategory(): void {

  }
  //----------event xử lý di chuyển Enter--------------------------------------
  tongtien: number = 0;
  maxcot: number = 13;

  
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn_DV(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Don_Vi.toLowerCase().indexOf(term) > -1 || item.Ten_Don_Vi.toLowerCase().indexOf(term) > -1;
  }
  
  comboSeleted: NgSelectComponent;

  public save_chondoituong2(item: any) {
    let tdoituong = [];
    tdoituong.push(item);
    this.save.emit(tdoituong);
  }
  public save_chondoituong() {  
    let tdoituong = [];
    this.save.emit(tdoituong);

  

  }
  closeModal_chondoituong() {
    let tdoituong =null;
    this.save.emit(tdoituong);
  }
  onLoaiNguoiNop(row: any) {
    this.nhomdoituongid = row.Id;
    //console.log(loai);
  }

  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }
   
  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }


  

  

  
  

}
